export const firebaseConfig = {
    apiKey: "AIzaSyDla_yKfqwGJ0u0Kneh6wN8h9i-KgSRTPk",
    authDomain: "yardyard-ac61d.firebaseapp.com",
    projectId: "yardyard-ac61d",
    storageBucket: "yardyard-ac61d.appspot.com",
    messagingSenderId: "475200775094",
    appId: "1:475200775094:web:64f0528aef4522dec59717"
  };